import { WherebyBotRoleName } from '../enums/Whereby'

// Whereby service clients do not count as connected people; the AI assistant still does.
const WHEREBY_BOT_ROLE_NAMES = new Set(Object.values(WherebyBotRoleName))
const WHEREBY_BOT_NAME_FRAGMENTS = ['recorder', 'caption', 'transcri']

export type WherebyParticipantNameSource = {
  displayName?: string | null
  metadata?: { displayName?: string | null }
  userName?: string | null
  username?: string | null
  externalId?: string | null
}

export const getWherebyParticipantDisplayName = (
  participant: WherebyParticipantNameSource | undefined,
  fallback: string
): string =>
  participant?.displayName ||
  participant?.metadata?.displayName ||
  participant?.userName ||
  participant?.username ||
  fallback

// The name someone joins a call with: their display name, else their address before the @, else nothing.
export const getWherebyCallDisplayName = (person?: { displayName?: string | null; email?: string | null }): string =>
  person?.displayName?.trim() || person?.email?.split('@')[0] || ''

export const isWherebyBotParticipant = (participant: {
  roleName?: string | null
  displayName?: string | null
}): boolean => {
  const roleName = (participant.roleName ?? '').trim().toLowerCase() as WherebyBotRoleName
  if (WHEREBY_BOT_ROLE_NAMES.has(roleName)) return true
  const displayName = (participant.displayName ?? '').toLowerCase()
  return WHEREBY_BOT_NAME_FRAGMENTS.some((fragment) => displayName.includes(fragment))
}
